import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { MyApplicationsModule } from '@features/my-applications/my-applications.module';
import { CopyApplicationModalComponent } from './copy-application-modal/copy-application-modal.component';

@NgModule({
  imports: [
    GCCoreModule,
    MyApplicationsModule
  ],
  declarations: [
    CopyApplicationModalComponent
  ],
  exports: [
    CopyApplicationModalComponent
  ]
})
export class CopyApplicationModule { }
